import { CollectionAccountResponse } from "../contracts/CollectionAccountResponse";
import { DebitMandateResponse } from "../contracts/DebitMandateResponse";
import { CollectionAccount } from "../models/CollectionAccount";
import { DebitMandate } from "../models/DebitMandate";

// The wire serializes absent optionals as JSON null; coerce to undefined so the
// model's optional fields behave.
export const mapResponseToCollectionAccount = (
  resp: CollectionAccountResponse
): CollectionAccount => ({
  status: resp.status,
  country: resp.country ?? undefined,
  chargesEnabled: resp.chargesEnabled,
  detailsSubmitted: resp.detailsSubmitted,
  payoutsEnabled: resp.payoutsEnabled,
  disabledReason: resp.disabledReason ?? undefined,
  sepaCurrencySupported: resp.sepaCurrencySupported,
  methods: resp.methods ?? [],
  currency: resp.currency,
});

export const mapResponseToDebitMandate = (resp: DebitMandateResponse): DebitMandate => ({
  id: resp.id,
  memberId: resp.memberId,
  status: resp.status,
  bankLast4: resp.bankLast4 ?? undefined,
  dateCreated: resp.dateCreated,
  dateModified: resp.dateModified,
  method: resp.method,
  label: resp.label ?? undefined,
});
